import { useState } from "react";
import "./Contact.css";
import config from "../Config/Config.json";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email";
    if (!formData.mobile.trim()) newErrors.mobile = "Mobile number is required";
    else if (!/^\d{10}$/.test(formData.mobile)) newErrors.mobile = "Mobile must be 10 digits";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required";
    if (!formData.message.trim()) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // clear error on change
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const first_name = formData.firstName
    const last_name = formData.lastName
    const email = formData.email
    const mobile = formData.mobile
    const subject = formData.subject
    const message = formData.message
    const mailtoLink = `mailto:${config.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      `Name: ${first_name} ${last_name}\nEmail: ${email}\nMobile: ${mobile}\n\nMessage:\n${message}`
    )}`;

    window.location.href = mailtoLink;
  };

  return (
    <div className="contact-div-base">
      <div className="contact-container">
        <div className="contact-div-1">
          <h1>Contact</h1>
          <div className="contact-subtitle">Looking forward to hearing from you</div>

          <div className="contact-block">
            <div className="contact-title">Phone</div>
            <div className="contact-subtitle">
              <a className="contact-link" href={`tel:${config.mobile}`}>
                {config.mobile}
              </a>
            </div>
          </div>

          <div className="contact-block">
            <div className="contact-title">Email</div>
            <div className="contact-subtitle">
              <a className="contact-link" href={`mailto:${config.email}`}>
                {config.email}
              </a>
            </div>
          </div>
        </div>

        <div className="contact-div-2">
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="form-row">
              <div className="input-container">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  className={`input-half ${errors.firstName ? "input-error" : ""}`}
                  value={formData.firstName}
                  onChange={handleChange}
                  aria-invalid={!!errors.firstName}
                />
                {errors.firstName && <span className="error-text">{errors.firstName}</span>}
              </div>

              <div className="input-container">
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  className={`input-half ${errors.lastName ? "input-error" : ""}`}
                  value={formData.lastName}
                  onChange={handleChange}
                  aria-invalid={!!errors.lastName}
                />
                {errors.lastName && <span className="error-text">{errors.lastName}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className="input-container">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className={`input-half ${errors.email ? "input-error" : ""}`}
                  value={formData.email}
                  onChange={handleChange}
                  aria-invalid={!!errors.email}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
              </div>

              <div className="input-container">
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile"
                  className={`input-half ${errors.mobile ? "input-error" : ""}`}
                  value={formData.mobile}
                  onChange={handleChange}
                  aria-invalid={!!errors.mobile}
                />
                {errors.mobile && <span className="error-text">{errors.mobile}</span>}
              </div>
            </div>

            <div className="input-container">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                className={`input-full ${errors.subject ? "input-error" : ""}`}
                value={formData.subject}
                onChange={handleChange}
                aria-invalid={!!errors.subject}
              />
              {errors.subject && <span className="error-text">{errors.subject}</span>}
            </div>

            <div className="input-container">
              <textarea
                name="message"
                placeholder="Message"
                className={`textarea-full ${errors.message ? "input-error" : ""}`}
                value={formData.message}
                onChange={handleChange}
                aria-invalid={!!errors.message}
              />
              {errors.message && <span className="error-text">{errors.message}</span>}
            </div>

            <div className="submit-row">
              <button
                type="submit"
                className="submit-button"
                disabled={loading}
                aria-busy={loading}
              >
                {loading ? "Sending..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
